import React from 'react';
import { Container } from 'reactstrap';

const AssessmentMethodology = () => {
  return (
    <Container className="py-5">
      <div className="legal-document">
        <h1 className="mb-4">Assessment Methodology Disclosure</h1>
        
        <section className="mb-4">
          <h2>1. Overview</h2>
          <p>This document discloses the methodology used in our SME and Supplier ESG Readiness Tool, which evaluates companies' Environmental, Social, and Governance (ESG) practices and their alignment with the United Nations Sustainable Development Goals (SDGs).</p>
        </section>

        <section className="mb-4">
          <h2>2. Assessment Framework</h2>
          <h3>2.1 Core Components</h3>
          <ul>
            <li><strong>Environmental Assessment:</strong> Evaluation of environmental impact, resource management, and climate action</li>
            <li><strong>Social Assessment:</strong> Analysis of labor practices, human rights, and community engagement</li>
            <li><strong>Governance Assessment:</strong> Review of corporate governance, ethics, and compliance</li>
            <li><strong>SDG Alignment:</strong> Measurement of contribution to UN Sustainable Development Goals</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>3. Scoring Methodology</h2>
          <h3>3.1 Scoring Components</h3>
          <ul>
            <li>Environmental Score (30%)</li>
            <li>Social Score (30%)</li>
            <li>Governance Score (20%)</li>
            <li>SDG Contribution Score (20%)</li>
          </ul>

          <h3>3.2 Scoring Scale</h3>
          <ul>
            <li>0-20: Initial Stage</li>
            <li>21-40: Developing Stage</li>
            <li>41-60: Established Stage</li>
            <li>61-80: Advanced Stage</li>
            <li>81-100: Leading Stage</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>4. Assessment Process</h2>
          <h3>4.1 Data Collection</h3>
          <ul>
            <li>Self-reported information through structured questionnaires</li>
            <li>Supporting documentation uploads</li>
            <li>Third-party data verification where applicable</li>
            <li>Historical performance tracking</li>
          </ul>

          <h3>4.2 Validation Process</h3>
          <ul>
            <li>Automated data validation checks</li>
            <li>Manual review of supporting documentation</li>
            <li>Cross-reference with public information</li>
            <li>Quality assurance procedures</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>5. Key Performance Indicators (KPIs)</h2>
          <h3>5.1 Environmental KPIs</h3>
          <ul>
            <li>Carbon emissions</li>
            <li>Energy consumption</li>
            <li>Waste management</li>
            <li>Water usage</li>
          </ul>

          <h3>5.2 Social KPIs</h3>
          <ul>
            <li>Employee diversity</li>
            <li>Health and safety metrics</li>
            <li>Community investment</li>
            <li>Labor practices</li>
          </ul>

          <h3>5.3 Governance KPIs</h3>
          <ul>
            <li>Board composition</li>
            <li>Ethics and compliance</li>
            <li>Risk management</li>
            <li>Transparency and reporting</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>6. Assessment Types</h2>
          <h3>6.1 Readiness Assessment</h3>
          <p>Comprehensive evaluation of current ESG practices and SDG alignment.</p>

          <h3>6.2 Progress Assessment</h3>
          <p>Measurement of improvement over time, comparing current performance with previous assessments.</p>
        </section>

        <section className="mb-4">
          <h2>7. Results and Reporting</h2>
          <h3>7.1 Assessment Reports</h3>
          <ul>
            <li>Overall ESG score</li>
            <li>Component-wise breakdown</li>
            <li>SDG contribution analysis</li>
            <li>Improvement recommendations</li>
            <li>Comparative industry positioning</li>
          </ul>

          <h3>7.2 Data Usage</h3>
          <ul>
            <li>Individual company reports</li>
            <li>Aggregated industry insights</li>
            <li>Research and benchmarking</li>
            <li>Progress tracking</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>8. Limitations and Disclaimers</h2>
          <ul>
            <li>Assessment results are based on self-reported data</li>
            <li>Scores are relative to industry standards</li>
            <li>Results should not be considered as financial advice</li>
            <li>Assessment methodology may be updated periodically</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>9. Updates to Methodology</h2>
          <p>We reserve the right to update this methodology to reflect:</p>
          <ul>
            <li>Changes in industry standards</li>
            <li>New regulatory requirements</li>
            <li>Updated SDG frameworks</li>
            <li>Improved assessment techniques</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>10. Contact Information</h2>
          <p>For questions about our assessment methodology, please contact:</p>
          <ul>
            <li>Email: info@globalcompactsa.org.za</li>
            <li>Phone: +27 11 771 41 42</li>
            <li>Address: 26 Melville Road, Johannesburg, South Africa</li>
          </ul>
        </section>
      </div>
    </Container>
  );
};

export default AssessmentMethodology; 